import TuneIcon from '@mui/icons-material/Tune';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { BaseActionProps } from '../types';

export const Filter: React.FC<BaseActionProps> = (props) => {
  const { disabled, onClick, type } = props;

  const { t } = useTranslation();

  return (
    <Tooltip title={t('COMMON.FILTER')} placement="top">
      <IconButton
        type={type}
        disabled={disabled}
        color="primary"
        size="medium"
        onClick={onClick}
      >
        <TuneIcon />
      </IconButton>
    </Tooltip>
  );
};
